export default __webpack_public_path__ + "static/get-customized-report-e5019e89926e81a0d210d7d4c5e0e88e.svg";